"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("./index"));
const divisions_1 = require("selectors/divisions");
const members_1 = require("selectors/members");
// selectors
const teams_1 = require("selectors/teams");
const user_1 = require("selectors/user");
const mapStateToProps = (state) => {
    // not archived and teams that user is the commissioner for
    const myLeagues = (0, lodash_1.filter)((0, divisions_1.divisions)(state), (d) => !d.isArchived && (0, lodash_1.some)((0, members_1.commissionerDivisionIds)(state), (id) => id === d.id));
    return {
        membersLoaded: (0, members_1.membersLoaded)(state),
        teamsLoaded: (0, teams_1.teamsLoaded)(state),
        isCommissionerOfAnything: (0, members_1.isCommissionerOfAnything)(state),
        user: (0, user_1.getUser)(state),
        activeTeams: (0, teams_1.activeTeams)(state),
        retiredTeams: (0, teams_1.retiredTeams)(state),
        recentTeam: (0, teams_1.recentTeam)(state),
        teams: (0, teams_1.getTeams)(state),
        myLeagues,
    };
};
exports.mapStateToProps = mapStateToProps;
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps)(index_1.default);
